export default "__VITE_PUBLIC_ASSET__a144af5a__"